module.exports = __webpack_public_path__ + "img/neu-computer.ea78d4d2.png";